import React from 'react';

import ButtonDropdown from 'components/ButtonDropdown';
import {formatDate} from 'utils/datetime';

import './styles.css';

const BaseInformation = ({
  refund,
  voidTransaction,
  syncRefund,
  addXeroIdToRefund
}) => {
  return (
    <div className="BaseInformation">
      <div className="data">
        <div className="section">
          <div className="header">Refund Date</div>
          <div className="text">
            {formatDate(refund.transaction.paymentDate)}
          </div>
        </div>
        <div className="section">
          <div className="header">Account</div>
          <div className="text">{`${refund.xeroAccount.code} - ${
            refund.xeroAccount.name
          }`}</div>
        </div>
      </div>
      <div className="options">
        <ButtonDropdown title="Refund options" className="scheduleOptions">
          <ButtonDropdown.Option
            disabled={!refund.transaction.isVoidable}
            onClick={voidTransaction}>
            Void transaction
          </ButtonDropdown.Option>
          <ButtonDropdown.Option
            disabled={!refund.isSyncable}
            onClick={syncRefund}>
            Sync refund
          </ButtonDropdown.Option>
          <ButtonDropdown.Option
            disabled={refund.xeroId}
            onClick={addXeroIdToRefund}>
            Add Xero ID
          </ButtonDropdown.Option>
        </ButtonDropdown>
      </div>
    </div>
  );
};

export default BaseInformation;
